import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Sparkles } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Dr. Misra" },
  { to: "/what-is-astrohomeopathy", label: "Astrohomeopathy" },
  { to: "/planets", label: "Planet Explorer" },
  { to: "/materia-medica", label: "Materia Medica" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl shadow-[0_4px_20px_-10px_rgba(15,23,42,0.15)]" : "bg-transparent"
      }`}
    >
      <div className="container-page flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src="https://customer-assets.emergentagent.com/job_astrohomeo-pro/artifacts/xtgzo2ot_121471.jpg" alt="Astrohomeopathy® logo" className="w-14 h-14 md:w-16 md:h-16 object-contain drop-shadow-sm" />
          <div className="leading-tight hidden sm:block">
            <div className="font-serif text-xl md:text-2xl text-[#0F172A]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Astrohomeopathy<sup className="text-[#D4AF37] text-sm">®</sup>
            </div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#0EA5E9]">Research & Education · Dr. Manish Misra</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-[#0EA5E9]" : "text-[#0F172A] hover:text-[#0EA5E9]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact#book" data-testid="nav-book-btn" className="btn-gold ml-3 text-sm py-2 px-5">
            Book Consultation
          </Link>
        </nav>

        <button
          className="lg:hidden text-[#0F172A]"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle navigation"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100" data-testid="nav-mobile-menu">
          <div className="container-page py-6 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-lg text-sm font-medium ${
                    isActive ? "bg-[#F0F9FF] text-[#0EA5E9]" : "text-[#0F172A]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact#book" onClick={() => setOpen(false)} className="btn-gold mt-3 text-sm">
              Book Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
